import React from 'react';
import {PuffLoader} from "react-spinners";

const Loader = (props) => {

    const styles = props.customStyles || "flex items-center justify-center row-start-1 row-end-21  xl:row-start-1 xl:row-end-21    col-start-1 col-end-25 lg:col-start-1 xl:col-start-1 xl:col-end-25"
    const size = props.size || 110;
    const color = props.type === "gold" ? "#B99354" : props.type === "purple" ? "#AABBCC" : "#FFFFFF";

    return (
        <div
            className={styles}>
            <PuffLoader
                color={color}
                size={size}
                speedMultiplier={0.5}
            />
        </div>
    );
};

export default Loader;